let _this;
const SCALE_MAX = 4;
import html2canvas from 'html2canvas';
import qrCode from 'qrcodejs2';
import addOptions from "../userCommon/addOptions.vue";
import scrollLoadList from "./scrollLoadList.vue";

export default {
  name: "user-printing",
  props: {
    // 权限，值为数组(分别为Card, Sticker, 空数组不做权限控制)
    permissionCodes: {
      type: Array,
      default(){
        return [];
      }
    },
    selectData: {
      type: Array,
      default(){
        return [];
      }
    },
    multipleType: {
      type: Boolean,
      default: false,
    },
  }, 
  components: { addOptions, scrollLoadList },
  data() {
    return {
      selectList: [],
      tipModal: false,
      printModal: false,
      thirdPrintModal: false, /*第三方打印*/
      printCardInfo: {},
      cardTempList: [],
      cardTempFlag: false,
      templateType: 0, /*模板類型 0 - card,1 - sticker , 2 - 第三方打印*/
      templateList: [],
      curTemplateId: null,
      templateInfo: {},
      initUserInfo: {},
      userInfo: {},/*用户信息*/
      saveDataFn: null,
      isSelect: false,
      checkTimer: '',
      scaleCount: 1, /*缩放倍数*/
      changeKey: 1,
      changeMyKey: 4,
      isDragging: false,   /*缩放和拖拽*/
      isClick: false,   /*拖动 不打开文件*/
      isUserCard: false,  /*判断是不是打印卡*/
      widthSkewxy: { xLeft: 0, xRight: 0 }, /*宽的留白*/
      isHandleMouseUp: false,
      initialWidth: 0, /*图片初始宽高*/
      initialHeight: 0,
      startX: 0,
      startY: 0,
      scale: 1,
      faceSize:window.g.uploadFaceSize,
      cardRole:true,
      stickerRole:true,
    }
  },
  mounted() {
    _this = this;
    eventBus.$on('userPrint', (userInfo, hasChanged, saveDataFn, isSelect, isFormCard) => {
      this.saveDataFn = saveDataFn;
      console.log(userInfo);
      this.initUserInfo = userInfo;
      this.isSelect = isSelect;
      this.checkPrintTypeRole(this.initUserInfo.userType)
      //userInfo和initialData对比，不相同则弹框提示保存；
      if (hasChanged) {
        this.tipModal = true;
      } else {
        this.initUserData(isFormCard);
      }
    })
  },
  beforeDestroy() {
    eventBus.$off('userPrint');
  },
  methods: {
    //判断该用户类型是否有打印该类型的卡模板的权限
    checkPrintTypeRole(type){
      console.log(type)
      switch (type) {
        case 0:
          this.cardRole = this.ApiService.staffPrintSetting.enablePrintCard;
          this.stickerRole = this.ApiService.staffPrintSetting.enablePrintSticker;
        break;
        case 1:
          this.cardRole = this.ApiService.visitorPrintSetting.enablePrintCard;
          this.stickerRole = this.ApiService.visitorPrintSetting.enablePrintSticker;
        break;  
        case 2:
          this.cardRole = this.ApiService.vendorPrintSetting.enablePrintCard;
          this.stickerRole = this.ApiService.vendorPrintSetting.enablePrintSticker;
        break; 
        case 3:
          this.cardRole = this.ApiService.tenantPrintSetting.enablePrintCard;
          this.stickerRole = this.ApiService.tenantPrintSetting.enablePrintSticker;
        break; 
      }
    },
    //切换  进入获取图片的宽度 并居中
    autoMiddle() {
      if ($('.image-box')) {
        _this.$nextTick(() => {
          const imageBox = $('.image-box');
          const imgBorder = $('.box-imgbox');
          imageBox.each(function (i, v) {
            let picWidth =parseFloat(imageBox.eq(i).css("width"));
            let picHeigth = imageBox.eq(i).height();
            let boxWidth = imgBorder.eq(i).width();
            let imgLeft = boxWidth / 2 - picWidth / 2;
            imageBox.eq(i).css({
              top: 0,
              left: imgLeft + 'px'
            })
            // 设置 html 自定义属性  左边留白距离 和 图片初始宽度
            imageBox.eq(i).attr({ widthSkewX: imgLeft, initialWidth: picWidth, initialHeight: picHeigth });
            // // 居中后图片左右留白的距离  // // 图片初始宽高 .用
          })
        })
      }

    },
    // 打印卡更换图片自动居中
    changePhotoMiddle(index) {
      // 获取盒子和图片的节点
      if ($('.image-box')) {
        // // 更换图片 居中图片
        this.$nextTick(() => {
          const imageBox = $("#image" + index);
          const imgBorder = $('#box-imgbox' + index);
          const imgFace = $("#face" + index);
          const faceImgBox = $('#face-imgbox' + index);
          changeMiddle(imageBox, imgBorder);
          changeMiddle(imgFace, faceImgBox);
          // 更换图片居中函数
          function changeMiddle(imageBox, imgBorder) {
            let boxHeight = imgBorder.height();
            imageBox.css({
              height: boxHeight + 'px',
              width: 'auto',
            })
            let picWidth = imageBox.width();
            let picHeigth = imageBox.height();
            let boxWidth = imgBorder.width();
              imageBox.css({
              width: picWidth+'px',
            })
            let imgLeft = boxWidth / 2 - picWidth / 2;
            imageBox.css({
              top: 0,
              left: imgLeft + 'px'
            })
             // 设置 html 自定义属性  左边留白距离 和 图片初始宽度
            imageBox.attr({ widthSkewX: imgLeft, initialWidth: picWidth, initialHeight: picHeigth });
          }
        })
      }
      //图片和位置归零
    },
    //员工卡 鼠标按下 
    handleMouseDown(e, child, index) {
      let _e=e;
      let _index=index;
      this.isDragging = true;
      this.isClick = true;
      _this.startX = e.clientX;
      _this.startY = e.clientY;
      this.isHandleMouseUp = true;
      let body=document.body;
      $(".image-box").css({'cursor':'pointer'})
      // 鼠标抬起事件
     body.addEventListener('mouseup', (event) => {
        let _e1=_e;
        _this.handleMouseUp(event, child, _index,_e1);
     },{ once: true });                      
    },
    //员工打印卡 鼠标移动
    handleMouseMove(e) {
      // 移动获取鼠标的位置
      // 按下鼠标 拖动图片移动
      if (this.isDragging) {
        e.preventDefault(); // 阻止外层容器滚动
        let el = $(e.target)
        let deltaX = e.clientX - this.startX;
        let deltaY = e.clientY - this.startY;
        if( deltaX!==0 || deltaY!==0){
          this.isClick = false;
        }
        let imgLeft = parseFloat(el.css("left")); 
        let imgTop = parseFloat(el.css("top"));;
        imgLeft += deltaX;
        imgTop += deltaY;
        // 离顶部
        el.css({
          top: imgTop + 'px',
          left: imgLeft + 'px'
        })
        this.startX = e.clientX;
        this.startY = e.clientY;
        
      }
    },
    // 鼠标抬起 
    handleMouseUp(e, child, index,_e) {
      _e.preventDefault()
      let el=$(_e.target)
      _this.isDragging = false
      if (_this.isHandleMouseUp) {
        _this.scaleBorder(e, child, index,_e)
          // 打印卡 的样式变化
        _this.showBorder(index,child);
          // 是否是是盒子内的抬起鼠标事件
        _this.isHandleMouseUp = false;
         $(".image-box").css({'cursor':'default'})
      }
    },
    handleImageClick(e, child, index) {
      if (this.isClick) {
      } else {
        // 阻止事件冒泡
        e.stopPropagation();
      }
    },
    // 用户卡片缩放事件  滚轮滑动缩放事件
    handleWheel(e, child, index) {
      e.preventDefault();//缩放时阻止外边的滚动条滚动
      let _e=e;
      let el = $(e.target);
      let mouseToBorderX = e.offsetX;
      let mouseToBorderY = e.offsetY;
      // 获取元素width,height,left,top;注意元素为relative或absolute定位
      // 设置一下缩放幅度 ,值越大缩放的越快
      let ratio = e.deltaY < 0 ? 0.1 : -0.1;
      child.scale = child.scale * (1 + ratio)
      // 设置缩放后的宽高
      // 避免达到缩放边界再缩放造成的位置移动  2、2
      child.scale = Math.max(child.scale, 1);
      let initialWidth = el.attr('initialWidth');
      let initialHeight = el.attr('initialHeight');
      let scaleNum = (el.height() * (1 + ratio) / initialHeight);
      // 以鼠标原点为中心缩放
      let imgTop = parseFloat(el.css('top')) - mouseToBorderY * ratio;
      let imgLeft = parseFloat(el.css('left')) - mouseToBorderX * ratio;
      el.css({
        width: initialWidth * child.scale + 'px',
        height: initialHeight * child.scale + 'px',
        top: imgTop + 'px',
        left: imgLeft + 'px'
      })
      // // 打印卡缩放边界函数
      this.scaleBorder(e, child, index,_e);
      // // 打印卡的样式变化
      _this.showBorder(index,child);

    },
    // 打印卡打印的图片的随 展示图片移动
    showBorder(index,child){
    // 打印卡的样式变化
        let imgbox=$('#image' + index);
        let faceImgbox=$('#face' + index);
        let initialWidthPint = imgbox.attr("initialWidth");
        let initialHeightPint = imgbox.attr("initialHeight");
          let imgTopPint=imgbox.css("top");
          let imgLeftPint=imgbox.css("left");
          faceImgbox.css({
            width: initialWidthPint * child.scale + 'px',
            height: initialHeightPint * child.scale + 'px',
            top: imgTopPint,
            left: imgLeftPint
          })
    },

    // 打印卡缩放边界函数
    scaleBorder: function (e, child, index,_e) {
      // 下边界判断条件
      // 移动的当前图片元素
      let el = $(_e.target);
      // // 获取初始盒子高度
      let boxWidth = $('#box-imgbox' + index).width();
      let initialHeight = $("#image" + index).attr("initialHeight");
      let imageBoxH = $("#image" + index).height();
      let imageBoxWid = $("#image" + index).width();
      let bottomDistance = imageBoxH - initialHeight;
      let leftDistance = imageBoxWid - boxWidth;
      // 缩放图片距离判断 缩放 上下
      let imgTop = parseFloat(el.css('top'))
      if (imgTop > 0) {
        // 缩小就还原
        el.css({
          top: 0,
        })
      }
      else if (imgTop + bottomDistance < 0) {
        el.css({
          top: -bottomDistance + 'px'
        })
      }
      let imageBoxW = el.width();
      let xLeft = el.attr("widthSkewX");
      let initialWidth = el.attr("initialWidth");
      // 有留白的 右边留白边界到盒子左边的距离
      let xRight = parseFloat(xLeft) + parseFloat(initialWidth);
      // 没有留白的 右边留白边界到盒子左边的距离
      let longxRight=el.width()-boxWidth;
      let imgLeft = parseFloat(el.css('left'));
      // 有留白 左右   
      if (el.width() <=boxWidth) {
        // 左边 
        if(imgLeft > xLeft)
        el.css({ left: parseFloat(xLeft) + 'px' });
        // 右边 当图片宽度小于等于盒子里图片初始位置的距离时
        if (xRight >= el.width()) {
          if(imgLeft + el.width() <= xRight)
          el.css({ left: xRight - el.width() + 'px' });
        }
        // 右边 当图片宽度大于盒子里图片初始位置的距离时    
        else if (xRight <= el.width()) {
         if( xRight-el.width() >= imgLeft)
         el.css({ left: xRight-el.width()  + 'px' });  
        }
      }
      else if(el.width()>boxWidth) {
        // 放大后没有留白
        // 左边   放进来有留白 后来放大了
        if(xLeft>0){
          let rightDistance = el.width() - boxWidth;
          if(imgLeft > xLeft)
          el.css({ left:parseFloat(xLeft) +'px' });
          // 右边
          if(imgLeft < -rightDistance-xLeft)
          el.css({ left: -rightDistance- xLeft+ 'px' });
        }else{
          // 放进来就没有留白
           if(imgLeft> 0)
           el.css({ left:0 +'px' });
          //  右边
          if(-longxRight>imgLeft)
          el.css({ left:-longxRight + 'px' });
        }
      }
    },
    saveAndPrint: function () {
      this.saveDataFn(false, (result) => {
        if (result) {
          this.tipModal = false;
          this.initUserData();
        }
      })
    },
    //isFormCard 是否从卡管理入口进来打印的
    initUserData: function (isFormCard) {
      if (this.selectData && this.selectData.length > 0) {
        this.selectList = this.selectData;
      }
      let userInfo = JSON.parse(JSON.stringify(_this.initUserInfo));
      _this.templateInfo = {};
      if(this.$root.adminInfo.permissionCodes.indexOf(this.permissionCodes[0]) > -1){
        this.templateType = 0;
      }else if(this.$root.adminInfo.permissionCodes.indexOf(this.permissionCodes[1]) > -1){
        this.templateType = 1;
      }
      _this.getTemplateList(_this.getDefaultTemp);
      // 卡
      if (userInfo.cards && userInfo.cards.length > 0) {
        let mainType = _this.ApiService.cardSettingInfo.mainType;
        userInfo.cards[0].cardExtensionBaseDtos.forEach(card => {
          if (card.type === mainType) {
            userInfo.cardNo = mainType + ' - ' + card.no;
          }
        })
      } else {
        userInfo.cardNo = isFormCard ? userInfo.displayCard : '-'
      }
      // 有效期
      userInfo.validityStartDate = userInfo.validityStartDate || userInfo.validityStartTime;
      userInfo.validityEndDate = userInfo.validityEndDate || userInfo.validityEndTime;
      if(userInfo.isPermanent){ 
        userInfo.validity = _this.common.formatZoneDate(userInfo.validityStartDate,_this.$root.Time[_this.$root.Time.type].typeDateHM,2) + ' Till Profile End';
        let startDate = userInfo.validityStartDate = _this.common.formatZoneDate(userInfo.validityStartDate,_this.$root.Time[_this.$root.Time.type].typeDate,2);
        userInfo.validityStartDate = _this.moment(startDate,'DD-MM-YYYY').format('DD/MM/YYYY');
        userInfo.validityEndDate = 'Till Profile End';
      } else if (userInfo.validityStartDate || userInfo.validityEndDate) {
        userInfo.validity = _this.common.formatZoneDate(userInfo.validityStartDate, _this.$root.Time[_this.$root.Time.type].typeDateHM, 2) + ' - ' + _this.common.formatZoneDate(userInfo.validityEndDate, _this.$root.Time[_this.$root.Time.type].typeDateHM, 2);
        let startDate = _this.common.formatZoneDate(userInfo.validityStartDate, _this.$root.Time[_this.$root.Time.type].typeDate, 2);
        let endDate = _this.common.formatZoneDate(userInfo.validityEndDate, _this.$root.Time[_this.$root.Time.type].typeDate, 2);
        userInfo.validityStartDate = _this.moment(startDate, 'DD-MM-YYYY').format('DD/MM/YYYY');
        userInfo.validityEndDate = _this.moment(endDate, 'DD-MM-YYYY').format('DD/MM/YYYY');
      }
      else {
        userInfo.validity = '-';
        userInfo.validityStartDate = '-';
        userInfo.validityEndDate = '-';
      }

      // ID
      userInfo.identifyCardResults = userInfo.identifyCardResults || userInfo.identifyCards;
      if (userInfo.identifyCardResults && userInfo.identifyCardResults.length > 0) {
        userInfo.idNo = userInfo.identifyCardResults[0].no;
        userInfo.idType = this.common.icType[userInfo.identifyCardResults[0].type].label;
      } else {
        userInfo.idNo = '-'
      }

      // DCS Zone获取
      userInfo.dcsAccessZone = '';
      if (_this.initUserInfo.id) {
        _this.getDCSInfo(userInfo);
      }

      userInfo.department = userInfo.department || userInfo.departmentName;
      userInfo.tenantCompany = userInfo.tenantCompany || userInfo.tenantCompanyName;

      // User Type
      if (typeof (userInfo.userType) === 'number') {
        userInfo.userType = _this.common.userType[userInfo.userType].label;
      }

      // 卡打印时间
      userInfo.curTime = _this.moment().format('DD-MM-YYYY HH:mm');
      _this.userInfo = userInfo;
      if (_this.templateType === 2) {
        _this.openPrintCard();
        _this.getCardPrintInfo(userInfo);
      } else {
        _this.getTemplateList();
        _this.printModal = true;
      }
    },
    // 获取DCS信息
    getDCSInfo(userInfo) {
      this.$ajax.get('User/GetDcsZoneById?id=' + _this.initUserInfo.id).then(res => {
        if (res.data.success && res.data.data) {
          let result = res.data.data;
          if (result && result[0]) {
            userInfo.dcsAccessZone = result[0].dcsZoneDisplayName
          } else {
            userInfo.dcsAccessZone = '-'
          }
        }
      })
    },
    // 卡类型改变重新获取模板列表
    handleTemplateTypeChange: function () {
      _this.templateList = [];
      _this.getTemplateList(_this.getDefaultTemp);
    },
    // 查询所有模板
    getTemplateList: function (callback) {
      _this.$ajax.post('CardTemplate/QueryOptions', { enabledPaging: false, sortName: 'name', sortType: 1, templateType: _this.templateType }).then(function (res) {
        if (res.data.success) {
          _this.templateList = res.data.data.items;
          if (callback) {
            clearTimeout(_this.checkTimer);
            _this.checkTimer = setTimeout(function () {
              callback();
            }, 500)
          }
        }
      })
    },
    //检查是否清空已选
    checkSelectLayout:function(templateId){
      if(!templateId || !templateId.value){
        _this.templateInfo = {}
      }else{
        _this.getTemplateInfo(templateId.value);
      }
      _this.scaleCount = 1;
      _this.$nextTick(() => {
        initDraggable();
      }) 
    },
    // 根据模板Id获取模板信息
    getTemplateInfo: function (templateId) {
      _this.$ajax.get('CardTemplate/GetById?id=' + templateId, { headers: { noLoading: true } }).then(function (res) {
        if (res.data.success) {
          _this.templateInfo = JSON.parse(res.data.data.data);

          //图片模版 后台拿的数据
          _this.$nextTick(() => {
            if (_this.templateInfo.objects && _this.templateInfo.objects.length > 0) {
              _this.templateInfo.objects.forEach((data, index) => {
                // 增加left 和 top属性
                _this.$set(data, 'imgTopDistance', 0);
                _this.$set(data, 'imgLeftDistance', 0);
                _this.$set(data, 'scale', 1);
                _this.$set(data, 'initialWidthBox', 0);
                // 调用图片居中函数  
              _this.autoMiddle()

                // 条形码
                if (data.type === 'image' && data.strokeWidth === 3) {
                  _this.jsbarcode("#bar-code" + index, _this.userInfo[data.stroke] ? _this.userInfo[data.stroke] : 'Text Field', {
                    height: data.height * data.scaleY,//高度
                    displayValue: false,//是否在条形码下方显示文字
                    background: "#fff",//设置条形码的背景
                    lineColor: "#333",//设置条和文本的颜色。
                    margin: 0,//设置条形码周围的空白边距
                    text: ''
                  });
                  _this.jsbarcode("#bar-code-generate" + index, _this.userInfo[data.stroke] ? _this.userInfo[data.stroke] : 'Text Field', {
                    height: data.height * data.scaleY,//高度
                    displayValue: false,//是否在条形码下方显示文字
                    background: "#fff",//设置条形码的背景
                    lineColor: "#333",//设置条和文本的颜色。
                    margin: 0,//设置条形码周围的空白边距
                    text: ''
                  });

                  positionCorr(data, index);
                }
                // 二维码
                else if (data.type === 'image' && data.strokeWidth === 4) {
                  if (data.stroke === 'encryId') {
                    _this.generateQRCode(index);
                  } else {
                    new qrCode("qr-code" + index, {
                      width: data.height * data.scaleY,
                      height: data.height * data.scaleY, // 高度
                      text: _this.userInfo[data.stroke] ? _this.userInfo[data.stroke] : 'Text Field' // 二维码内容
                    });
                    new qrCode("qr-code-generate" + index, {
                      width: data.height * data.scaleY,
                      height: data.height * data.scaleY, // 高度
                      text: _this.userInfo[data.stroke] ? _this.userInfo[data.stroke] : 'Text Field' // 二维码内容
                    });
                  }
                } else if (data.type === 'textbox') {
                  data.editFlag = false;
                }
              });
              function positionCorr(data, index) {
                setTimeout(function () {
                  _this.judgeCenter(data, index);
                }, 100);
              }
            }
           
          })
        }
         
            _this.changeKey = _this.changeKey == 1 ? 2 : 1
            _this.changeMyKey = _this.changeMyKey == 4 ? 3 : 4
      })
    },
    // 二维码加密生成
    generateQRCode: function (index) {
      let params = {
        "userIds": _this.userInfo.id ? [_this.userInfo.id] : null
      };
      this.$ajax.post('User/GenerateQrCode', params).then((res) => {
        if (res.data.success) {
          let array = res.data.data;
          if (array && array.length > 0) {
            document.getElementById("qr-code" + index).setAttribute('src', 'data:image/jpg;base64,' + array[0].qrCode);
            document.getElementById("qr-code-generate" + index).setAttribute('src', 'data:image/jpg;base64,' + array[0].qrCode);
          }
        } else if (res.data.message) {
          _this.messageNotice('error', res.data.message);
        }
      });
    },

    // 判断二维码是否居中(在模板设置中的默认条码长度和生成的条码长度时不一致的)
    judgeCenter: function (qrCodeInfo, index) {
      if (qrCodeInfo.left.toFixed() === ((_this.templateInfo.width - (qrCodeInfo.width * qrCodeInfo.scaleX)) / 2).toFixed()) {
        let imgWid = '';
        if (qrCodeInfo.strokeWidth === 3) {
          imgWid = $('#bar-code' + index).width();
        }
        else if (qrCodeInfo.strokeWidth === 4) {
          imgWid = $('#qr-code' + index).width();
        }
        qrCodeInfo.left = (_this.templateInfo.width - imgWid) / 2;
      }
    },
    // 打印信息(帖子打印)
    printUserInfo: function () {
      if (JSON.stringify(_this.templateInfo) === '{}') {
        _this.messageNotice('error', 'Please select a template');
      } else if (this.templateType === 0) {
          // 对接打印机
          this.clickPrint();

        } else if (this.templateType === 1) {
          //打印贴纸
          // 打印时移除灰色边框 --颜色改为透明色
          $('.img-border').css('border', '2px solid transparent')
          this.$forceUpdate();
          $('#card-template-box').print({
            globalStyles: true
          });
          setTimeout(() => {
            $('.img-border').css('border', '2px solid #C4C4C4')
          }, 600);
        }
    },
    // 监听结束打印

    //删除卡号
    deleteItem: function (id) {
      _this.selectList = _this.selectList.filter((item) => {
        return id !== item.id;
      });
      setTimeout(() => {
        this.$refs.addOptions.initData();
      }, 1000)
    },
    // 选择数据
    checkOption: function (data) {
      _this.selectList = data;
    },

    /***************第三方卡打印*****************/
    openPrintCard: function () {
      this.cardTempFlag = false;
      this.getCardTemplate();
      this.printCardInfo.templateName = null;
      this.printCardInfo.photo = null;
      this.thirdPrintModal = true;
    },
    // 获取卡打印模板
    getCardTemplate: function () {
      this.$ajax.get('/api/CardPrinting/Templates', { baseURL: window.g.PRINT_ROOT }).then(function (res) {
        if (res.data.success) {
          _this.cardTempList = res.data.value;
        } else {
          _this.messageNotice('error', res.data.message);
        }
      });
    },
    getCardPrintInfo: function (userInfo) {
      _this.printCardInfo = {
        uuid: userInfo.id,
        icNo: userInfo.idNo,
        name: userInfo.name,
        faceFileBase64: userInfo.faceFileBase64,
      };
      if (userInfo.idType === 3) {
        _this.printCardInfo.employeeID = userInfo.idNo;
        _this.printCardInfo.icNo = null;
      } else {
        _this.printCardInfo.employeeID = null;
      }
      if (userInfo.department || userInfo.company || userInfo.tenantCompanyName) {
        _this.printCardInfo.companyName = userInfo.departmentName || userInfo.company || userInfo.tenantCompanyName;
      }
      if (userInfo.cardNo && userInfo.cards && userInfo.cards.length) {
        _this.printCardInfo.cardNumber = userInfo.cardNo.split('-')[1].trim();
      }
    },
    // 打印卡
    printCardData: function () {
      if (_this.printCardInfo.faceFileBase64) {
        _this.printCardInfo.photo = _this.printCardInfo.faceFileBase64;
      }

      if (!_this.printCardInfo.templateName) {
        _this.cardTempFlag = true;
        return;
      }
      _this.$ajax.post('/api/CardPrinting/UploadPrints', [_this.printCardInfo], { baseURL: window.g.PRINT_ROOT}).then(function (res) {
        if (res.data.success) {
          _this.messageNotice('success');
          _this.thirdPrintModal = false;
        } else {
          _this.messageNotice('error', res.data.message);
        }
      })
    },
    /***************第三方卡打印*****************/
    // 获取默认打印模板
    getDefaultTemp() {
      // 判断默认模板是否删除
      let defaultId = (this.templateType === 0 ? _this.ApiService.cardTemplate.card : _this.ApiService.cardTemplate.sticker);
      let flag = this.templateList.some(item => item.id === defaultId);
      if (flag) {
        _this.curTemplateId = defaultId;
        let defaultInfo = { value :defaultId};
        _this.checkSelectLayout(defaultInfo);
      } else {
        _this.curTemplateId = null;
      }
    },
    // 缩放
    scalePage: function (type) {
      if (type && _this.scaleCount > 0.2) {
        _this.scaleCount = _this.scaleCount - 0.1;
      } else if (!type && _this.scaleCount < 2) {
        _this.scaleCount = _this.scaleCount + 0.1;
      }
    },
    changeStroke(bol, index) {
      if (_this.templateInfo.objects[index].stroke) {
        _this.templateInfo.objects[index].editFlag = bol;
        _this.$forceUpdate();
        _this.$nextTick(() => {
          let dom = document.getElementById('card_input' + index)
          if (dom) {
            dom.focus();
          }
        });
      }
    },
    //导入之前 更换图片
   //导入之前
   beforeUpload: function (file,index,child) {
    // 必须大于20kb且小于配置的大小
    if (file && file.size > 20480 && file.size <= _this.faceSize * 1048576 ) {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = window.URL.createObjectURL(file);
      img.onload = function(e){
        if (this.width >= 150 && this.width <= 4096 && this.height >= 150 && this.height <= 4096) {
          if(_this.templateInfo.objects[index].stroke){
            let formatStr = file.name.substr(file.name.lastIndexOf(".")).toLowerCase();
            if (['.jpeg', '.jpg','.png'].indexOf(formatStr) > -1) {
              let reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = function () {
                let result = this.result.substring(this.result.indexOf('base64,') + 7)
                document.getElementById("image" + index).setAttribute('src','data:image/jpg;base64,' + result);
                document.getElementById("face" + index).setAttribute('src','data:image/jpg;base64,' + result);
                   // 更换图片 居中图片
                _this.changePhotoMiddle(index);
              };
              _this.$set(child,'scale',1);
            }else {
              _this.messageNotice('error', _this.common.errMsg);
            }
          }
        }else{
          _this.messageNotice('error', _this.common.errMsg);
        }
      }
    }else{
      _this.messageNotice('error', _this.common.errMsg);
    }
  },

    /* ****************************对接打印机**************************** */
    //确认打印方法
    clickPrint: function () {
      this.$root.isLoading = true;
      this.$forceUpdate();
      let _this = this;
      // 获取待转换内容 & 创建canvas
      let flex_item = document.getElementById('generate_card');
      flex_item.style.transform = "scale(2) rotate(-90deg)";

      // 将HTML生成图片
      setCanvas(flex_item);
      function setCanvas(dom) {
        setTimeout(() => {
          html2canvas(dom, {
            dpi: 350,
            useCORS: true, // 允许跨域
            canvas: null,
            backgroundColor: null,
            logging: true,
          }).then(function (canvas) {
            let img = canvas.toDataURL('image/jpeg', 1);
            // 图片旋转90度
            function rotateBase64Img(src, edg, callback) {
              let canvas = document.createElement("canvas");
              let ctx = canvas.getContext("2d");
              let imgW;//图片宽度
              let imgH;//图片高度
              let size;//canvas初始大小
              if (edg % 90 != 0) {
                console.error("旋转角度必须是90的倍数!");
                throw new Error('旋转角度必须是90的倍数!');
              }
              (edg < 0) && (edg = (edg % 360) + 360)
              const quadrant = (edg / 90) % 4; //旋转象限
              const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 }; //裁剪坐标
              let image = new Image();
              image.crossOrigin = "anonymous";
              image.src = src;
              image.onload = function () {
                imgW = image.width;
                imgH = image.height;
                size = imgW > imgH ? imgW : imgH;
                canvas.width = size * 10;
                canvas.height = size * 10;
                switch (quadrant) {
                  case 0:
                    cutCoor.sx = size;
                    cutCoor.sy = size;
                    cutCoor.ex = size + imgW;
                    cutCoor.ey = size + imgH;
                    break;
                  case 1:
                    cutCoor.sx = size - imgH;
                    cutCoor.sy = size;
                    cutCoor.ex = size;
                    cutCoor.ey = size + imgW;
                    break;
                  case 2:
                    cutCoor.sx = size - imgW;
                    cutCoor.sy = size - imgH;
                    cutCoor.ex = size;
                    cutCoor.ey = size;
                    break;
                  case 3:
                    cutCoor.sx = size;
                    cutCoor.sy = size - imgW;
                    cutCoor.ex = size + imgH;
                    cutCoor.ey = size + imgW;
                    break;
                }
                ctx.translate(size, size);
                ctx.rotate(edg * Math.PI / 180);
                ctx.drawImage(image, 0, 0);
                let imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
                if (quadrant % 2 == 0) {
                  canvas.width = imgW;
                  canvas.height = imgH;
                } else {
                  canvas.width = imgH;
                  canvas.height = imgW;
                }
                ctx.putImageData(imgData, 0, 0);
                callback(canvas.toDataURL())
              };
            }
            function callback(base64data) {
              let imgStr = base64data.split(',')[1];
              //将生成的图片传给打印程序
              _this.postPrinterCard(imgStr);
            }
            callback(img);
          });
        }, 1);
      };
    },
    
    //打印卡接口方法,调用打印程序
    postPrinterCard: function (imgStr) {
      let data = {
        "printerName": null,
        "frontBase64": imgStr,
        "backBase64": null,
      };
      this.$ajax.post('/api/Printer/DoPrint', data, { baseURL: window.g.print_root , headers:{noLoading:true}}).then(function (res) {
        if (res.data.success) {
          _this.$root.isLoading = false;
          _this.messageNotice('success');
        } else {
          _this.$root.isLoading = false;
          _this.messageNotice('error', res.data.message);
        }
      });
    },
  }
}
function initDraggable() {
  //移动地图
  // 如果拖动的是 Img
  $('.image-box').on('mousemove',function(e){
    e.stopPropagation();
    if (!e) {
      $('#template-details').draggable({
        scroll: false,
        start: function (e) {
        },
      });
    }
  })

}


// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/userPrinting.js